// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-title {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: left;
  text-transform: none;
}

#textArea {
  width: 100%;
  height: auto;
}

.post-user-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.06);
}

.user-comment-picture {
  height: 38px;
  width: 38px;
  border-radius: 50%;
}

.user-name {
  font-weight: 600;
}

.date {
  font-size: 0.8em;
  font-weight: 300;
}

.post-description {
  margin: 6px 16px 15px;
  font-family: var(--font);
  font-weight: 400;
}

.img-post {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
}

.divider {
  margin-top: 6px;
  margin-bottom: 6px;
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.04);
}

.post-n-comment-div {
  margin-left: 17px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.delete-btn {
  float: right;
  padding-right: 10px;
}

.align-texts-like {
  width: 100%;
  display: inline-flex;
  align-items: center;
}

.align-texts-comment {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}

.normal-text {
  font-size: 1.1em;
}

.total-likes {
  margin-left: 8px;
}

/* .input-comment {
    resize: none;
} */
.pos-btn-send {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-col-size {
  display: flex;
  align-items: center;
}

.btn-send-msg {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-send {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-more {
  text-align: center;
}

.icon-fixed {
  float: right;
}

#icon_fixed {
  width: 18px;
  height: 18px;
}

.st0 {
  fill: #808080;
}

.btn-attach-picture {
  font-size: 22px;
}

.display-flex-align {
  display: flex;
  align-items: center;
}

.float-right {
  float: right;
}

.float-left {
  float: left;
}

.separator-vertical {
  width: 1px;
  height: 55%;
  background: rgba(0, 0, 0, 0.1);
  margin-right: 6px;
}

#myImg {
  width: 45px;
  height: 45px;
  border-radius: 6px;
}

.description-input {
  padding-top: 10px;
  height: 45%;
  resize: none;
  background: #ffffff;
}

.text-input-ios {
  margin: 0 auto;
}

.text-input-md {
  margin: 0 auto;
}

.mg-card {
  margin-top: 4px;
}

.btn-default {
  padding: 8px;
  font-size: 1em;
  border-radius: 15px;
  min-width: 100%;
}

.post-img {
  width: 100%;
  max-height: 60%;
  border-radius: 8px !important;
}

.txt-mg {
  margin-left: 10px;
}

.icon-like {
  font-size: 1.3em;
}

.icon-not-like {
  font-size: 1.3em;
  color: #d3d3d3;
}

.icon-comment {
  margin-right: 3px;
  font-size: 1.3em;
}

.icon-trash {
  float: right;
}

.color-trash {
  color: #c91f1f;
}

.input-comment {
  padding: 5px;
  display: flex;
  border-top: 2px solid #ECEAF3;
}
.input-comment textarea {
  flex: 1;
  border: 0;
  border-bottom: 1px rgba(0, 0, 0, 0.3);
  border-style: solid;
  font-family: var(--font);
  font-weight: 400;
}
.input-comment > ion-buttons {
  width: 20%;
}
.input-comment > ion-buttons ion-button {
  border-radius: 30px;
  height: 44px;
  text-transform: none;
  width: 44px;
}
.input-comment > ion-buttons ion-button ion-icon {
  margin: auto;
  width: 20px;
  height: 20px;
}
.input-comment > ion-buttons ion-button span {
  display: none;
}

.social-sharing {
  float: right;
  font-size: 1.2em;
}

.more-options-btn {
  font-size: 1.4em;
}

.header-post-item {
  border: none !important;
  padding: 0 !important;
}
.header-post-item ion-avatar {
  width: 46px;
  height: 46px;
  border: 2px solid transparent;
  padding: 1px;
  cursor: pointer;
}
.header-post-item ion-avatar img {
  width: 44px;
}
.header-post-item .profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  margin: 0 auto;
  background: var(--bg-color);
  padding: 11px;
}
.header-post-item .profile-picture .cus-picture {
  width: 16px;
  height: 16px;
  margin: auto;
  border-radius: 0;
  opacity: 0.6;
}
.header-post-item .name-post {
  font-family: var(--font);
  font-weight: 600;
  cursor: pointer;
}
.header-post-item .post-date {
  font-family: var(--font);
  font-weight: 300;
  opacity: 0.5;
}

.post-card-content {
  padding: 0;
}
.post-card-content .post-img {
  max-height: 60%;
  display: block;
}

.isborwser {
  margin-bottom: 110px;
}
.isborwser .input-comment {
  margin: 0 !important;
}

.align-footer-post ion-col {
  display: flex;
}
.align-footer-post ion-col .like-container {
  display: flex;
  padding-left: 9px;
}
.align-footer-post ion-col .align-texts-comment {
  display: inline-flex;
}
.align-footer-post ion-col .nbr-likes-cmts {
  font-family: var(--font);
  font-weight: 300;
  font-size: 14px;
  margin: auto 7px;
}
.align-footer-post ion-col ion-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.write-cmt {
  width: 100%;
  display: flex;
  padding: 0 16px;
}
.write-cmt ion-avatar {
  width: 39px;
  height: 39px;
  margin-right: 10px;
}
.write-cmt ion-avatar .profile-picture {
  background: var(--bg-color);
  width: 39px;
  height: 39px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.write-cmt ion-avatar .profile-picture .cus-picture {
  height: 15px;
  width: 15px;
}
.write-cmt ion-label {
  border-radius: 0 13px 13px 13px;
  display: flex;
  width: calc(100% - 51px);
  padding: 5px 9px;
}
.write-cmt ion-label textarea {
  border-radius: 8px 8px 8px 8px;
  width: calc(100% - 50px);
  background: transparent;
  margin-right: 5px;
  padding: 7px !important;
}
.write-cmt ion-label button {
  margin: auto;
  width: 46px;
  height: 46px;
  border-radius: 7px;
  box-shadow: 1px 1px 1px #808080;
}
.write-cmt ion-label button ion-icon {
  width: 20px;
  height: 20px;
}

.comment ion-avatar {
  position: relative;
  top: -28px;
  height: 34px;
  width: 34px;
}
.comment ion-avatar .profile-picture {
  background: var(--bg-color);
  width: 34px;
  height: 34px;
  border-radius: 50%;
  padding: 10px;
}
.comment ion-avatar .profile-picture .cus-picture {
  height: 14px;
  width: 14px;
}
.comment ion-label {
  background: var(--bg-color);
  border-radius: 0 13px 13px 13px;
  padding: 10px 15px;
}
.comment ion-label > h2 {
  font-family: var(--font);
  font-weight: 600;
}
.comment ion-label > p {
  font-family: var(--font);
  font-weight: 400;
  margin: 6px 0;
}
.comment ion-label > .bottom-comment {
  display: flex;
  justify-content: space-between;
  font-family: var(--font);
  font-weight: 300;
  font-size: 12px;
}
.comment ion-label > .bottom-comment .btn-delete-cmt {
  position: absolute;
  top: 15px;
  right: 30px;
  font-size: 20px;
  color: #f00;
  cursor: pointer;
}

ion-footer {
  background: var(--bg-color-content);
}
ion-footer .input-comment {
  width: 100%;
  background: #fff;
}

.footer {
  position: fixed;
  bottom: 9px;
  width: 100%;
  z-index: 99999;
}
.footer .input-comment {
  width: 100%;
  background: rgb(141, 30, 30);
}

.background {
  min-height: 80vh !important;
}

@media screen and (min-width: 768px) {
  .input-comment ion-button {
    width: 130px !important;
  }
  .input-comment ion-button span {
    display: block !important;
    margin: auto auto auto 0;
  }
  .footer .input-comment {
    width: 70%;
    margin: auto;
  }
}
ion-card {
  max-width: none;
  margin: 0 auto 82px auto !important;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/feed-comment/feed-comment.component.scss"],"names":[],"mappings":"AAAA;EAEI,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;AAAJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,wBAAA;EAA0B,gBAAA;AAC9B;;AAEA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,+BAAA;AACJ;;AAEA;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;AACJ;;AAEA;EACI,YAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,oBAAA;EACA,mBAAA;AACJ;;AAEA;EAEI,oBAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;;GAAA;AAIA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;AADJ;;AAIA;EACI,aAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,WAAA;AADJ;;AAIA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;EACA,iBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,eAAA;AADJ;;AAIA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AADJ;;AAIA;EACI,WAAA;EACA,eAAA;EACA,6BAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,cAAA;AADJ;;AAIA;EACI,iBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,YAAA;EACA,aAAA;EAEA,6BAAA;AAFJ;AAGI;EACI,OAAA;EACA,SAAA;EACA,qCAAA;EACA,mBAAA;EACA,wBAAA;EAA0B,gBAAA;AAAlC;AAEI;EACI,UAAA;AAAR;AACQ;EACI,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AACZ;AAAY;EACI,YAAA;EACA,WAAA;EACA,YAAA;AAEhB;AAAY;EACI,aAAA;AAEhB;;AAIA;EACI,YAAA;EACA,gBAAA;AADJ;;AAOA;EACI,gBAAA;AAJJ;;AAMA;EACI,uBAAA;EACA,qBAAA;AAHJ;AAII;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAFR;AAGQ;EACI,WAAA;AADZ;AAII;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;EACA,aAAA;AAFR;AAGQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AADZ;AAII;EAGI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAHR;AAKI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,YAAA;AAFR;;AAMA;EACI,UAAA;AAHJ;AAII;EACI,eAAA;EACA,cAAA;AAFR;;AAKA;EACI,oBAAA;AAFJ;AAGI;EACI,oBAAA;AADR;;AAKI;EACI,aAAA;AAFR;AAGQ;EACI,aAAA;EAEA,iBAAA;AAFZ;AAIQ;EAEI,oBAAA;AAHZ;AAKQ;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,gBAAA;AAFZ;AAIQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAFZ;;AAMA;EACI,WAAA;EAAY,aAAA;EAAc,eAAA;AAD9B;AAEI;EACI,WAAA;EAAY,YAAA;EAAa,kBAAA;AAEjC;AADQ;EACI,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAGZ;AAFY;EACI,YAAA;EACA,WAAA;AAIhB;AAAI;EAEI,+BAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;AACR;AAAQ;EACI,8BAAA;EACA,wBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;AAEZ;AAAQ;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AAEZ;AAAY;EACI,WAAA;EACA,YAAA;AAEhB;;AAKI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAFR;AAGQ;EACI,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AADZ;AAEY;EACI,YAAA;EACA,WAAA;AAAhB;AAII;EACI,2BAAA;EACA,+BAAA;EACA,kBAAA;AAFR;AAGQ;EACI,wBAAA;EAA0B,gBAAA;AAAtC;AAEQ;EACI,wBAAA;EAA0B,gBAAA;EAC1B,aAAA;AACZ;AACQ;EACI,aAAA;EACA,8BAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAEZ;AADY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAGhB;;AAGA;EACI,mCAAA;AAAJ;AACI;EACI,WAAA;EACA,gBAAA;AACR;;AAEA;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AACJ;AAAI;EACI,WAAA;EACA,4BAAA;AAER;;AACA;EACI,2BAAA;AAEJ;;AAAA;EAEQ;IACI,uBAAA;EAEV;EADU;IACI,yBAAA;IACA,wBAAA;EAGd;EAEM;IACI,UAAA;IACA,YAAA;EAAV;AACF;AAGA;EACI,eAAA;EACA,mCAAA;EACA,WAAA;AADJ","sourcesContent":["ion-title {\n    // position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    text-align: left;\n    text-transform: none;\n}\n\n#textArea {\n    width: 100%;\n    height: auto;\n}\n\n.post-user-avatar {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    border: 1px solid;\n    border-color: rgba(0, 0, 0, 0.06);\n}\n\n.user-comment-picture {\n    height: 38px;\n    width: 38px;\n    border-radius: 50%;\n}\n\n.user-name {\n    font-weight: 600;\n}\n\n.date {\n    font-size: 0.8em;\n    font-weight: 300;\n}\n\n.post-description {\n    margin: 6px 16px 15px;\n    font-family: var(--font); font-weight: 400;;\n}\n\n.img-post {\n    width: 100%;\n    max-height: 200px;\n    object-fit: cover;\n}\n\n.divider {\n    margin-top: 6px;\n    margin-bottom: 6px;\n    width: 100%;\n    height: 1px;\n    background: rgba(0, 0, 0, 0.04);\n}\n\n.post-n-comment-div {\n    margin-left: 17px;\n    margin-top: 5px;\n    margin-bottom: 10px;\n}\n\n.delete-btn {\n    float: right;\n    padding-right: 10px;\n}\n\n.align-texts-like {\n    width: 100%;\n    display: inline-flex;\n    align-items: center;\n}\n\n.align-texts-comment {\n    //width: 100%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-end;\n}\n\n.normal-text {\n    font-size: 1.1em;\n}\n\n.total-likes {\n    margin-left: 8px;\n}\n\n/* .input-comment {\n    resize: none;\n} */\n\n.pos-btn-send {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.custom-col-size {\n    display: flex;\n    align-items: center;\n}\n\n.btn-send-msg {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    float: left;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.icon-send {\n    width: 20px;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.view-more {\n    text-align: center;\n}\n\n.icon-fixed {\n    float: right;\n}\n\n#icon_fixed {\n    width: 18px;\n    height: 18px;\n}\n\n.st0 {\n    fill: #808080;\n}\n\n.btn-attach-picture {\n    font-size: 22px; // color: #000000;\n}\n\n.display-flex-align {\n    display: flex;\n    align-items: center;\n}\n\n.float-right {\n    float: right;\n}\n\n.float-left {\n    float: left\n}\n\n.separator-vertical {\n    width: 1px;\n    height: 55%;\n    background: rgba(0, 0, 0, 0.1);\n    margin-right: 6px;\n}\n\n#myImg {\n    width: 45px;\n    height: 45px;\n    border-radius: 6px;\n}\n\n.description-input {\n    padding-top: 10px;\n    height: 45%;\n    resize: none;\n    background: #ffffff;\n}\n\n.text-input-ios {\n    margin: 0 auto;\n}\n\n.text-input-md {\n    margin: 0 auto;\n}\n\n.mg-card {\n    margin-top: 4px;\n}\n\n.btn-default {\n    padding: 8px;\n    font-size: 1em;\n    border-radius: 15px;\n    min-width: 100%;\n}\n\n.post-img {\n    width: 100%;\n    max-height: 60%;\n    border-radius: 8px !important;\n}\n\n.txt-mg {\n    margin-left: 10px;\n}\n\n.icon-like {\n    font-size: 1.3em;\n}\n\n.icon-not-like {\n    font-size: 1.3em;\n    color: #d3d3d3\n}\n\n.icon-comment {\n    margin-right: 3px;\n    font-size: 1.3em;\n}\n\n.icon-trash {\n    float: right;\n}\n\n.color-trash {\n    color: #c91f1f\n}\n\n.input-comment {\n    padding: 5px;\n    display: flex;\n    // margin-top: 17px;\n    border-top: 2px solid #ECEAF3;\n    textarea {\n        flex: 1;\n        border: 0;\n        border-bottom: 1px rgba(0, 0, 0, 0.3);\n        border-style: solid;\n        font-family: var(--font); font-weight: 400;;\n    }\n    > ion-buttons{\n        width: 20%;\n        ion-button{\n            border-radius: 30px;\n            height: 44px;\n            text-transform: none;\n            width: 44px; \n            ion-icon{\n                margin: auto;\n                width: 20px;\n                height: 20px;\n            }\n            span{\n                display: none;\n            }\n        }\n    }\n}\n\n.social-sharing {\n    float: right;\n    font-size: 1.2em;\n}\n\n// .header-post-item {\n// }\n\n.more-options-btn {\n    font-size: 1.4em;\n}\n.header-post-item{\n    border: none !important;\n    padding: 0 !important;\n    ion-avatar{\n        width: 46px;\n        height: 46px;\n        border: 2px solid transparent;\n        padding: 1px;\n        cursor: pointer;\n        img{\n            width: 44px;\n        }\n    }\n    .profile-picture {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        object-fit: cover;\n        object-position: center;\n        margin: 0 auto;\n        background: var(--bg-color);\n        padding: 11px;\n        .cus-picture {\n            width: 16px;\n            height: 16px;\n            margin: auto;\n            border-radius: 0;\n            opacity: 0.6;\n        }\n    }\n    .name-post {\n        // margin-left: 8px;\n        // margin-bottom: 8px;\n        font-family: var(--font); font-weight: 600;;\n        cursor: pointer;\n    }\n    .post-date{\n        font-family: var(--font); font-weight: 300;;\n        opacity: 0.5;\n    }\n}\n\n.post-card-content{\n    padding: 0;\n    .post-img {\n        max-height: 60%;\n        display: block;\n    }\n}\n.isborwser{\n    margin-bottom: 110px;\n    .input-comment{\n        margin: 0 !important;\n    }\n}\n.align-footer-post {\n    ion-col{\n        display: flex;\n        .like-container {\n            display: flex;\n            // width: 20%;\n            padding-left: 9px;\n        }\n        .align-texts-comment {\n            // width: 20%;\n            display: inline-flex;\n        }\n        .nbr-likes-cmts{\n            font-family: var(--font); font-weight: 300;;\n            font-size: 14px;\n            margin: auto 7px;\n        }\n        ion-icon{\n            width: 20px;\n            height: 20px;\n            cursor: pointer;\n        }\n    }\n}\n.write-cmt{\n    width: 100%;display: flex;padding: 0 16px;\n    ion-avatar{\n        width: 39px;height: 39px;margin-right: 10px;\n        .profile-picture{\n            background: var(--bg-color);\n            width: 39px;\n            height: 39px;\n            border-radius: 50%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            .cus-picture{\n                height: 15px;\n                width: 15px;\n            }\n        }\n    }\n    ion-label{\n        // background: var(--bg-color);\n        border-radius: 0 13px 13px 13px;\n        display: flex;\n        width: calc(100% - 51px);\n        padding: 5px 9px;\n        textarea{\n            border-radius: 8px 8px 8px 8px;\n            width: calc(100% - 50px);\n            background: transparent;\n            margin-right: 5px;\n            padding: 7px !important;\n        }\n        button{\n            margin: auto;\n            width: 46px;\n            height: 46px;\n            border-radius: 7px;\n            box-shadow: 1px 1px 1px #808080;\n            // align-self: flex-end;\n            ion-icon{\n                width: 20px;\n                height: 20px;\n            }\n        }\n    }\n}\n\n.comment{\n    ion-avatar{\n        position: relative;\n        top: -28px;\n        height: 34px;\n        width: 34px;\n        .profile-picture{\n            background: var(--bg-color);\n            width: 34px;\n            height: 34px;\n            border-radius: 50%;\n            padding: 10px;\n            .cus-picture{\n                height: 14px;\n                width: 14px;\n            }\n        }\n    }\n    ion-label{\n        background: var(--bg-color);\n        border-radius: 0 13px 13px 13px;\n        padding: 10px 15px;\n        > h2 {\n            font-family: var(--font); font-weight: 600;;\n        }\n        > p{\n            font-family: var(--font); font-weight: 400;;\n            margin: 6px 0;\n        }\n        >.bottom-comment{\n            display: flex;\n            justify-content: space-between;\n            font-family: var(--font); font-weight: 300;;\n            font-size: 12px;\n            .btn-delete-cmt {\n                position: absolute;\n                top: 15px;\n                right: 30px;\n                font-size: 20px;\n                color: #f00;\n                cursor: pointer;\n            }\n        }\n        \n    }\n}\nion-footer {\n    background: var(--bg-color-content);\n    .input-comment{\n        width: 100%;\n        background: #fff;\n    }\n}\n.footer{\n    position: fixed;\n    bottom: 9px;\n    width: 100%;\n    z-index: 99999;\n    .input-comment{\n        width: 100%;\n        background: rgb(141, 30, 30);\n    }\n}\n.background{\n    min-height: 80vh !important;\n}\n@media screen and (min-width: 768px) {\n    .input-comment{\n        ion-button{\n            width: 130px !important;\n            span{\n                display: block !important;\n                margin: auto auto auto 0;\n            }\n        }\n    }\n    .footer {\n        .input-comment{\n            width: 70%;\n            margin: auto;\n        }\n    }\n}\nion-card {\n    max-width: none;\n    margin: 0 auto 82px auto !important;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
